import { Theme } from '@material-ui/core';
import { styledBy } from '../../models/AlmeColorMapping';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ breakpoints, palette, shadows, spacing }: Theme) {
    const mainShadow = shadows[5];
    const gutterPx = spacing(2);
    const gutterPxSm = spacing(1);
    const dividerColor = palette.divider;
    const dividerBorder = `1px solid ${dividerColor}`;

    const augmentPrimaryColor = { main: palette.primary.dark };
    const augmentSecondaryColor = { main: palette.secondary.dark };
    const augmentPrimary = palette.augmentColor(augmentPrimaryColor);
    const augmentSecondary = palette.augmentColor(augmentSecondaryColor);

    return {
        root: {
            position: 'fixed' as const,
            right: gutterPx + gutterPxSm,
            bottom: gutterPx * 2 + gutterPxSm,
            borderRadius: spacing(0),
            display: 'flex',
            alignItems: 'flex-end',
            [breakpoints.down('sm')]: {
                right: gutterPxSm,
                bottom: gutterPx + gutterPxSm,
            },
        },
        icon: {
            color: styledBy('color', {
                default: palette.getContrastText(palette.background.default),
                divider: palette.getContrastText(palette.divider),
                initial: palette.primary.contrastText,
                paper: palette.getContrastText(palette.background.paper),
                primary: palette.primary.contrastText,
                secondary: palette.secondary.contrastText,
            }),
            backgroundColor: styledBy('color', {
                default: palette.background.default,
                divider: palette.divider,
                initial: 'initial',
                paper: palette.background.paper,
                primary: palette.primary.main,
                secondary: palette.secondary.main,
            }),
            '&:hover': {
                backgroundColor: styledBy('color', {
                    default: palette.background.default,
                    divider: palette.divider,
                    initial: 'initial',
                    paper: palette.background.paper,
                    primary: augmentPrimary.main,
                    secondary: augmentSecondary.main,
                }),
                color: styledBy('color', {
                    default: palette.getContrastText(palette.background.default),
                    divider: palette.getContrastText(palette.divider),
                    initial: palette.primary.contrastText,
                    paper: palette.getContrastText(palette.background.paper),
                    primary: augmentPrimary.contrastText,
                    secondary: augmentSecondary.contrastText,
                }),
            },
            boxShadow: mainShadow,
            zIndex: 2,
        },
        button: {
            color: styledBy('color', {
                default: palette.getContrastText(palette.background.default),
                divider: palette.getContrastText(palette.divider),
                initial: palette.primary.contrastText,
                paper: palette.getContrastText(palette.background.paper),
                primary: palette.primary.contrastText,
                secondary: palette.secondary.contrastText,
            }),
            backgroundColor: styledBy('color', {
                default: palette.background.default,
                divider: palette.divider,
                initial: 'initial',
                paper: palette.background.paper,
                primary: palette.primary.main,
                secondary: palette.secondary.main,
            }),
            '&:hover': {
                backgroundColor: styledBy('color', {
                    default: palette.getContrastText(palette.background.default),
                    divider: palette.getContrastText(palette.divider),
                    initial: palette.primary.contrastText,
                    paper: palette.getContrastText(palette.background.paper),
                    primary: augmentPrimary.main,
                    secondary: augmentSecondary.main,
                }),
                color: styledBy('color', {
                    default: palette.getContrastText(palette.background.default),
                    divider: palette.getContrastText(palette.divider),
                    initial: palette.primary.contrastText,
                    paper: palette.getContrastText(palette.background.paper),
                    primary: augmentPrimary.contrastText,
                    secondary: augmentSecondary.contrastText,
                }),
            },
            zIndex: 1,
            marginLeft: spacing(0) - gutterPxSm,
        },
        card: {
            border: dividerBorder,
            backgroundColor: palette.background.default,
            minWidth: 350,
        },
        cardHeader: {
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            padding: spacing(1),
        },
        cardActions: {
            padding: spacing(0),
            paddingBottom: spacing(1),
        },
    };
}